var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineScheduler({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2414_1325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V7H16V18Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 6.75,
    fill: "white",
    stroke: "#373737",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2414_1325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.943 14.9905C18.943 14.9225 18.9345 14.846 18.9175 14.778C18.909 14.5315 18.977 14.1575 19.47 14.183C19.5465 14.2085 19.6315 14.217 19.7165 14.217C20.1925 14.217 20.575 13.8345 20.575 13.3585C20.575 12.8825 20.184 12.5 19.708 12.5C19.232 12.5 18.8495 12.8825 18.8495 13.3585C18.8495 13.4435 18.858 13.52 18.8835 13.5965C18.875 13.826 18.722 14.132 17.991 14.132H13.792C13.316 14.132 12.9335 14.5145 12.9335 14.9905C12.9335 15.73 13.537 15.849 13.537 15.849C13.775 15.849 13.9705 16.0445 13.9705 16.2825C13.9705 16.5205 13.775 16.716 13.537 16.716C13.537 16.716 12.9335 16.818 12.9335 17.5745C12.9335 18.0505 13.316 18.433 13.792 18.433H16.3675C16.8435 18.433 17.226 18.0505 17.226 17.5745C17.226 17.0985 16.835 16.7075 16.3675 16.7075H14.8205C14.5825 16.7075 14.387 16.512 14.387 16.274C14.387 16.036 14.5825 15.8405 14.8205 15.8405H18.0845C18.552 15.849 18.943 15.4665 18.943 14.9905ZM14.132 19.283C13.656 19.283 13.2735 19.6655 13.2735 20.1415C13.2735 20.6175 13.656 21 14.132 21C14.608 21 14.9905 20.6175 14.9905 20.1415C14.9905 19.6655 14.608 19.283 14.132 19.283Z",
    fill: "url(#paint0_linear_2414_1325)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2414_1325",
    x1: 20.575,
    y1: 12.5,
    x2: 15.2175,
    y2: 22.2545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B01BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA3F85"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2414_1325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2414_1325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.5,
    height: 8.5,
    fill: "white",
    transform: "translate(12.5 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineScheduler);
export default __webpack_public_path__ + "static/media/online-scheduler.8cd10d54e198c2b16e55702ac4007542.svg";
export { ForwardRef as ReactComponent };